import { IconProps } from "../../types/utils";

const Empty = ({ color, dimension, ...props }: IconProps) => (
  <svg
    width={dimension || 32}
    height={dimension || 32}
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M27.4056 4.56432C26.9884 4.14718 26.3143 4.14718 25.8974 4.56432L21.2117 9.25004C19.7674 8.12684 17.9573 7.45164 15.9851 7.45164C11.2724 7.45164 7.45164 11.2723 7.45164 15.9851C7.45164 17.9575 8.12684 19.7674 9.25004 21.2116L4.56432 25.8974C4.14718 26.3145 4.14718 26.9886 4.56432 27.4056C4.77236 27.6136 5.04537 27.7182 5.31861 27.7182C5.59165 27.7182 5.86467 27.6138 6.07271 27.4057L10.7584 22.72C12.2038 23.8432 14.0127 24.5184 15.985 24.5184C20.6976 24.5184 24.5184 20.6977 24.5184 15.9849C24.5184 14.0126 23.8432 12.2037 22.72 10.7584L27.4058 6.07271C27.8227 5.65556 27.8227 4.98146 27.4056 4.5645L27.4056 4.56432ZM9.58476 15.9851C9.58476 12.4555 12.4551 9.58512 15.9848 9.58512C17.3649 9.58512 18.6409 10.0289 19.6871 10.7744L10.7742 19.6873C10.0286 18.6411 9.58485 17.3652 9.58485 15.985L9.58476 15.9851ZM22.3848 15.9851C22.3848 19.5148 19.5144 22.3851 15.9848 22.3851C14.6046 22.3851 13.3287 21.9414 12.2825 21.1958L21.1954 12.2829C21.9409 13.3292 22.3847 14.6051 22.3847 15.9852L22.3848 15.9851Z"
      fill={color || "#242424"}
    />
  </svg>
);

export default Empty;
